/* Nakoda Silver — scroll engine.
   Mirrors the mechanics of the reference build (loiseau.framer.website):
     · sticky stacked panels          -> pure CSS, nothing here
     · images held at scale(1.18) and panned inside a clipped frame  [data-pan]
     · hero scrubbed on scroll (scale down, drift up, fade)          [data-hero]
     · headings that rise word by word                               .rw
     · counters / progress rails driven by section progress          [data-rail]
   One rAF loop, one scroll listener, everything read then written. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NARROW = window.matchMedia('(max-width:780px)').matches;
  var STEP = NARROW ? 28 : 55;      // per-word delay
  var CAP  = NARROW ? 260 : 700;    // never stagger longer than this

  /* ---------- word-split headings ---------- */
  [].forEach.call(document.querySelectorAll('.rw'), function (el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var html = el.innerHTML.split(/(<br\s*\/?>)/i).map(function (chunk) {
      if (/^<br/i.test(chunk)) return chunk;
      return chunk.split(/(\s+)/).map(function (w) {
        if (!w.trim()) return w;
        return '<span class="rw-w"><span class="rw-i">' + w + '</span></span>';
      }).join('');
    }).join('');
    el.innerHTML = html;
    [].forEach.call(el.querySelectorAll('.rw-i'), function (s, i) {
      s.style.transitionDelay = Math.min(i * STEP, CAP) + 'ms';
    });
  });

  /* ---------- reveal on enter ----------
     IntersectionObserver is the primary trigger, but it is not something we can
     bet the page on: mobile browsers throttle observers in backgrounded tabs, a
     bfcache restore can drop callbacks, and any of that would leave whole
     sections permanently invisible. So a cheap scroll sweep runs alongside it
     and reveals anything that reaches the viewport. Each element leaves the
     pending list the moment it is shown, so the sweep costs nothing once the
     page has been read through. */
  var pending = [].slice.call(document.querySelectorAll('.rv,.rw'));

  function show(el) { el.classList.add('in'); }

  function sweep() {
    if (!pending.length) return;
    var h = window.innerHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      var el = pending[i];
      if (el.classList.contains('in')) { pending.splice(i, 1); continue; }
      var r = el.getBoundingClientRect();
      /* Only an upper bound. An element whose top has crossed the fold line is
         either in view or already scrolled past, and both must end up visible.
         Requiring it to still be *inside* the viewport made the rule miss
         anything a fast flick-scroll jumped over between two rAF samples --
         which on a phone left whole sections stuck at opacity 0 for good. */
      if (r.top < h * 1.05) { show(el); pending.splice(i, 1); }
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: NARROW ? '0px 0px 4% 0px' : '0px 0px -10% 0px', threshold: NARROW ? 0.01 : 0.08 });
    [].forEach.call(pending, function (el) { io.observe(el); });
  } else {
    [].forEach.call(pending, function (el) { show(el); });
    pending.length = 0;
  }

  var sweepTick = false;
  function onSweep() {
    if (sweepTick || !pending.length) return;
    sweepTick = true;
    requestAnimationFrame(function () { sweepTick = false; sweep(); });
  }
  window.addEventListener('scroll', onSweep, { passive: true });
  window.addEventListener('resize', onSweep, { passive: true });
  window.addEventListener('pageshow', sweep);
  window.addEventListener('load', sweep);
  setTimeout(sweep, 400);
  sweep();

  if (RM) return;

  /* ---------- scrubbed effects ---------- */
  var pans  = [].slice.call(document.querySelectorAll('[data-pan]'));
  var hero  = document.querySelector('[data-hero]');
  var rails = [].slice.call(document.querySelectorAll('[data-rail]'));
  if (!pans.length && !hero && !rails.length) return;

  var vh = window.innerHeight, ticking = false;
  /* Phones composite these full-bleed images every frame. A smaller scale means a
     smaller layer and a shorter pan, which is the difference between smooth and
     stuttery on a mid-range Android. Matches the CSS override at 780px. */
  var SMALL = window.matchMedia('(max-width:780px)').matches;
  var PAN_S = SMALL ? 1.16 : 1.18;
  var PAN_A = SMALL ? 1 : 1;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* thin progress line under the header so scrolling always reads as motion */
  var prog = document.createElement('div');
  prog.className = 'scrollprog';
  document.body.appendChild(prog);

  function frame() {
    ticking = false;

    /* hero: as it leaves, the image settles from 1.12 to 1.0 and drifts up */
    if (hero) {
      var hr = hero.getBoundingClientRect();
      var hp = clamp(-hr.top / (hr.height || 1), 0, 1);         // 0 at top, 1 when scrolled past
      /* drift only — scale belongs to the ambient ken-burns keyframes on the <img>,
         so the two never fight over the same transform */
      var img = hero.querySelector('[data-hero-img]');
      if (img) img.style.transform = 'translate3d(0,' + (hp * (SMALL ? 12 : 7)).toFixed(2) + '%,0)';
      var cap = hero.querySelector('[data-hero-cap]');
      if (cap) {
        cap.style.transform = 'translate3d(0,' + (hp * (SMALL ? 74 : 46)).toFixed(1) + 'px,0)';
        cap.style.opacity = (1 - clamp(hp * 1.5, 0, 1)).toFixed(3);
      }
    }

    /* pans: image sits at scale(1.18) and slides across its frame as the frame crosses */
    for (var i = 0; i < pans.length; i++) {
      var el = pans[i], r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) continue;
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);       // 0 entering, 1 leaving
      var amt = parseFloat(el.getAttribute('data-pan')) || 7;    // % of travel
      var im = el.firstElementChild;
      if (!im) continue;
      var off = (0.5 - p) * amt * PAN_A;
      /* Full-bleed panels on mobile are anchored bottom (see CSS): in every worn
         shot the jewellery sits at ~95% of the frame height, so a centre-origin
         zoom crops the product straight off. Anchored to the bottom the zoom eats
         hair instead - but only while the offset stays >= 0, since a negative
         offset would lift the image and open a gap under it. Hence 0..4%. */
      if (SMALL && el.parentNode && el.parentNode.className.indexOf('panel') > -1) {
        off = (1 - p) * 4;
      }
      im.style.transform = 'scale(' + PAN_S + ') translate3d(0,' + off.toFixed(2) + '%,0)';
    }

    /* page scroll progress */
    var max = document.documentElement.scrollHeight - vh;
    prog.style.transform = 'scaleX(' + (max > 0 ? clamp(window.scrollY / max, 0, 1).toFixed(4) : 0) + ')';

    /* rails: a 0->100% progress line through a section */
    for (var j = 0; j < rails.length; j++) {
      var s = rails[j], sr = s.getBoundingClientRect();
      var sp = clamp((vh * 0.75 - sr.top) / (sr.height || 1), 0, 1);
      var bar = s.querySelector('[data-rail-bar]');
      if (bar) bar.style.transform = 'scaleX(' + sp.toFixed(4) + ')';
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(frame); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Height-only resizes on mobile are the URL bar collapsing, not a real layout
     change. Recomputing vh there makes every scrubbed transform jump, so we only
     react when the width actually changes (rotation or a desktop window drag). */
  var vw = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === vw) return;
    vw = window.innerWidth; vh = window.innerHeight; onScroll();
  }, { passive: true });
  window.addEventListener('orientationchange', function () {
    setTimeout(function () { vw = window.innerWidth; vh = window.innerHeight; onScroll(); }, 250);
  });

  frame();
})();

/* ---------- product card film: hover on desktop, touch on phones ----------
   The <video> ships with no src, only data-src, so a grid of ten costs nothing until
   someone actually interacts — a phone would otherwise pull ~25MB on page load.

   Touch gets the same behaviour as hover, on touchstart. The video has
   pointer-events:none so the tap still passes through to the link and navigates; if the
   finger stays down or the user scrolls, the film plays. Only one plays at a time. */
(function () {
  var cards = [].slice.call(document.querySelectorAll('.card'));
  if (!cards.length) return;
  var canHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function play(card) {
    var v = card.querySelector('.card-vid');
    if (!v) return;
    if (!v.src) {
      v.src = v.getAttribute('data-src');
      v.addEventListener('loadeddata', function () { v.classList.add('ready'); }, { once: true });
    }
    v.classList.add('playing');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});   /* autoplay policy — ignore */
  }

  function stop(card) {
    var v = card.querySelector('.card-vid');
    if (!v) return;
    v.classList.remove('playing');
    v.pause();
    try { v.currentTime = 0; } catch (e) {}      /* next time starts clean, not mid-shot */
  }

  function stopAllExcept(keep) {
    cards.forEach(function (c) { if (c !== keep) stop(c); });
  }

  cards.forEach(function (card) {
    if (!card.querySelector('.card-vid')) return;

    if (canHover) {
      card.addEventListener('mouseenter', function () { play(card); });
      card.addEventListener('mouseleave', function () { stop(card); });
    } else {
      /* passive: never block the tap that navigates */
      card.addEventListener('touchstart', function () {
        stopAllExcept(card);
        play(card);
      }, { passive: true });
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) cards.forEach(stop);
  });
})();

/* ---------- PDP image cycler ----------
   Crossfades the stills inside one fixed 4:5 stage. Auto-advances, pauses while the
   pointer is over it, and stops permanently the moment someone uses a dot — once a
   person has chosen a slide, moving it under them is rude. */
(function () {
  var g = document.querySelector('[data-gallery]');
  if (!g) return;
  var slides = [].slice.call(g.querySelectorAll('.g-slide'));
  var dots = [].slice.call(g.querySelectorAll('.g-dot'));
  if (slides.length < 2) return;

  var i = 0, timer = null, stopped = false;

  function show(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    dots.forEach(function (d, k) {
      d.classList.toggle('is-on', k === i);
      d.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
  }
  function start() { if (!stopped && !timer) timer = setInterval(function () { show(i + 1); }, 4200); }
  function stop() { clearInterval(timer); timer = null; }

  dots.forEach(function (d) {
    d.addEventListener('click', function () {
      stopped = true; stop();
      show(parseInt(d.getAttribute('data-go'), 10));
    });
  });

  g.addEventListener('mouseenter', stop);
  g.addEventListener('mouseleave', start);
  /* don't animate in a background tab, and don't let intervals pile up on return */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
})();
